import { LedgerView } from "./LedgerView";

export function CoinLedgerPage() {
  return (
    <LedgerView
      title="Coin Ledger"
      helperText="The complete, append-only ledger — every coin-affecting event in the app, unfiltered. Corrections are always a new offsetting entry, never an edit to history."
    />
  );
}
